// extracted by mini-css-extract-plugin
export default {"mini":"styles-module__mini__src-labstep-web-core-Modal-Wizard-__x_e3"};